import { FC } from 'react'

import clsx from 'clsx'

import { DestinationFeedItem } from 'shared/api/tours/main-page'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

interface Props {
  direction: DestinationFeedItem
  onClick: () => void
}

export const TourDirectionCard: FC<Props> = ({ direction, onClick }) => {
  return (
    <button
      type="button"
      className={s.card}
      onClick={onClick}
    >
      <ImageOptimized
        src={direction.image}
        alt=""
        className={s.image}
        wrapperClassName={s.imageWrapper}
      />
      <span className={s.overlay} />
      <span className={clsx('extra-bold-14', s.name)}>
        {direction.destination_country.name}
      </span>
    </button>
  )
}
